import { ApplicationEntity } from "@/model/entity/application-entity"
import { FieldDescriptor, FieldTypeEnum } from "@/model/entity//field-descriptor"
import { Country } from "../country/country"
import { Type } from "class-transformer"
import { countryList } from "@/model/service/country/country-service"

export class CutOffTime extends ApplicationEntity {

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "user_administration.company.postal_code"
  })
  postalCode: string

  @FieldDescriptor({
    fieldType: FieldTypeEnum.SELECT,
    fieldPrettyName: "user_administration.company.country",
    fieldName: "country",
    selectionFieldDescription: {
      displayKey: "name",
      valueKey: "isoCodeAlpha2",
      values: countryList,
      i18n: true
    },
    columnWidth: "100",
    isRequired: true
  })
  @Type(() => Country)
  country: Country

  @FieldDescriptor({
    fieldType: FieldTypeEnum.TEXT,
    fieldPrettyName: "cut_off_time.hours"
  })
  time: string

  constructor(
    id?: number,
    postalCode: string = "",
    country: any = null,
    time: string = ""
  ) {
    super(id)
    this.postalCode = postalCode
    this.country = country
    this.time = time
  }
}
